import { IUser } from 'src/app/core/classes/user.class';
import { Injectable } from '@angular/core';
import { LoggedInUserService } from './core/loggedInUser/logged-in-user.service';

export interface Theme {
  mainColor?: any;
  secundaryColor?: any;
  id?: any;
  label?: string;
  name?: string;
  className?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeConfigurationService {
  loggedInUser: IUser = null;
  public selectedTheme: Theme = null;

  ListThemes: Theme[] = [
    {
      mainColor: '#0d47a1',
      secundaryColor: '#f44336',
      id: 1,
      label: 'blueTheme',
      name: 'Blue',
      className: 'customThemeClass'
    },
    {
      mainColor: '#004d40',
      secundaryColor: '#880e4f',
      id: 2,
      label: 'tealTheme',
      name: 'Teal',
      className: 'tealThemeClass'
    },
    {
      mainColor: '#b71c1c',
      secundaryColor: '#4db6ac',
      id: 3,
      label: 'redTheme',
      name: 'Red',
      className: 'redThemeClass'
    },
    {
      mainColor: '#2e7d32',
      secundaryColor: '#ffc107',
      id: 4,
      label: 'greenTheme',
      name: 'Green',
      className: 'greenThemeClass'
    },
    {
      mainColor: '#FF9000',
      secundaryColor: '#00796B',
      id: 5,
      label: 'orangeTheme',
      name: 'Orange',
      className: 'orangeThemeClass'
    }
    // {
    //   mainColor: '#1a237e', id: 4,
    //   label: 'indigoTheme', name: 'Indigo',
    //   className: 'indigoThemeClass'
    // },
    // {
    //   mainColor: '#e65100', id: 5,
    //   label: 'orangeTheme', name: 'Orange',
    //   className: 'orangeThemeClass'
    // },
    // {
    //   mainColor: '#fdd835', id: 4,
    //   label: 'yellowTheme', name: 'Yellow',
    //   className: 'yellowThemeClass'
    // },
    // {
    //   mainColor: '#4a148c', id: 6,
    //   label: 'purpleTheme', name: 'Purple',
    //   className: 'purpleThemeClass'
    // },
  ];

  constructor(private loggedInUserService: LoggedInUserService) {
    this.loggedInUser = this.loggedInUserService.getLoggedInUser();
    if (this.loggedInUser) {
      const itemId = this.loggedInUser?.AgencyUser?.[0]?.Agency?.themeColor ?? 0;
      if (!itemId) {
        this.selectedTheme = this.ListThemes[0];
      } else {
        this.selectedTheme = this.ListThemes[itemId - 1];
      }
    } else if (this.loggedInUserService.getAgencyUser()) {
      const agency = this.loggedInUserService.getAgencyUser();
      this.selectedTheme = this.ListThemes[agency.themeColor - 1];
    } else {
      this.selectedTheme = this.ListThemes[0];
    }

    this.selectedTheme = (this.selectedTheme) ? this.selectedTheme : this.ListThemes[0];
    document.getElementById('BodyAppClass').className = this.selectedTheme.className;
  }

  public getArrayThemes(): Theme[] {
    return this.ListThemes;
  }
}
